import en from 'vuetify/es5/locale/en';

export default en;
